import { useMemo } from 'react';

import { encode } from 'uqr';

/**
 * A QR code drawn as a single SVG path: no canvas, no injected markup. Always dark on white,
 * whatever the theme, because that is what a phone camera reads reliably.
 */
export function QrCode({
  value,
  label,
  size = 184,
}: {
  value: string;
  label: string;
  size?: number;
}) {
  const { path, modules } = useMemo(() => {
    const { data } = encode(value, { ecc: 'M', border: 2 });
    let d = '';
    data.forEach((row, y) => {
      row.forEach((dark, x) => {
        if (dark) {
          d += `M${String(x)} ${String(y)}h1v1h-1z`;
        }
      });
    });
    return { path: d, modules: data.length };
  }, [value]);

  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${String(modules)} ${String(modules)}`}
      shapeRendering="crispEdges"
      style={{ background: '#fff', borderRadius: 4 }}
    >
      <path d={path} fill="#000" />
    </svg>
  );
}
